export default __webpack_public_path__ + "static/media/Versions - vs Official vs Films_05.7da3439f.jpg";